<template>
    <section :class="css.container">
        <div :class="css.cover">
            <div class="container" :class="css.header_body">
                <div :class="css.title" class="font-variable color-1 font-bold">{{ $t("SequenceHomology") }}</div>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/disease/mark.png" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("SequenceHomologyDescript1") }}</div>
                        <div :class="css_normalize.indexs">
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript2") }}</div>
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript3") }}</div>
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript4") }}</div>
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript5") }}</div>
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript6") }}</div>
                            <div :class="css_normalize.index">{{ $t("SequenceHomologyDescript7") }}</div>
                        </div>
                        <div :class="css_normalize.context">{{ $t("SequenceHomologyDescrit8") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.not" class="container text-hint" v-if="!exist">{{ $t("Placeholder.NotModuleDescript") }}</div>

        <div :class="css.body" ref="body" class="container" v-loading="loading" v-else>
            <div :class="css.selectors">
                <div :class="[css.selector, css_normalize.radio]" v-for="select in selectors">
                    <div :class="css.name" class="font-bold color-1">{{ options.name[select.species] }}:</div>
                    <div :class="css.context" v-if="!select.value">{{ $t("Unknown") }}</div>
                    <div :class="css.context" v-else>
                        <!-- * 基因信息 -->
                        <span v-if="select.value == $route.params.id">{{ select.name }}</span>
                        <project-route v-else :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: select.value } }">
                            {{ select.name }}
                        </project-route>

                        <!-- * 基因序列信息 -->
                        <project-route
                            v-if="select.value"
                            :class="css_normalize.assets"
                            :to="{ name: 'BioSequenceResult', params: { id: select.value } }">
                            {{ $t("ViewGeneticSequence") }}
                        </project-route>
                    </div>
                </div>
            </div>

            <div :class="css.infos">
                <table v-for="colspan in data" :class="css.combination">
                    <tbody>
                        <template v-for="row in colspan">
                            <tr :class="css.header">
                                <td colspan="3">
                                    <img :class="css.image" :title="row.name" :src="row.icon" />
                                    <div :class="css.name" class="font-variable font-bold color-1">{{ row.name }}</div>
                                    <UiTooltip :class="css.extra" v-if="row.params && row.params.length" :classExtraName="css.view">
                                        <div :class="css.region">{{ $t("SequenceAlignment") }}</div>
                                        <template #content>
                                            <div :class="css.options">
                                                <div :class="css.option" v-for="value in row.params" @click="methods.comparison(value)">
                                                    {{ value.title }}
                                                </div>
                                            </div>
                                        </template>
                                    </UiTooltip>
                                </td>
                            </tr>

                            <tr :class="[css.info, value.scale < 34 && css.highlight]" v-for="(value, key) in row.data">
                                <!-- * 种族名称 -->
                                <td>{{ useSpeciesName(key) }}</td>

                                <!-- * 可视化 -->
                                <td :class="[css.schedule, value.scale && css.forbidden]">
                                    <div :class="css.content" v-if="!value.route">
                                        <div :class="css.name" class="font-variable">{{ value.name }}</div>
                                        <span :class="css.rect" :style="{ width: value.scale ? `${value.scale}%` : '100%' }"></span>
                                    </div>
                                    <ProjectRoute :class="css.content" v-else :to="value.route" target="_blank">
                                        <div :class="css.name" class="font-variable">{{ value.name }}</div>
                                        <span :class="css.rect" :style="{ width: value.scale ? `${value.scale}%` : '100%' }"></span>
                                    </ProjectRoute>
                                </td>

                                <!-- * 结果 -->
                                <td>{{ value.context }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiRadioGroup, UiRadio, UiTooltip, UiIcon } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
import { PropsOption } from "../../index";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
const define = defineProps(PropsOption);

//* 组合函数
const { refs, nodes, methods, options } = useComposable(define);
const { selectors, loading, exist, data } = refs;
const { body } = nodes;
const { render, hidden } = methods;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
